
import messages from '../../locale/jsonMessages';


const validate = values => {

    const errors = {};

    if (values.isSpecialPrice <= 0) {
        errors.isSpecialPrice = messages.specialPriceInvalid;
    }

    return errors;
}

export default validate;
